// Match the execution-limit responses from current and older gateways.
export function isOverScanRejection(err) {
  const message = String(err?.message || err).toLowerCase();
  return message.includes("exceeded an execution limit")
    || message.includes("too many bytes")
    || message.includes("query scanned too much data");
}
